const indexItems = [
  { title: '明星恋情', count: 128, icon: 'ri-heart-line', color: 'text-primary-600 bg-primary-100' },
  { title: '综艺名场面', count: 96, icon: 'ri-tv-line', color: 'text-accent-600 bg-accent-100' },
  { title: '网红翻车', count: 85, icon: 'ri-alert-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '影视争议', count: 73, icon: 'ri-film-line', color: 'text-primary-600 bg-primary-100' },
  { title: '品牌风波', count: 64, icon: 'ri-hand-coin-line', color: 'text-accent-600 bg-accent-100' },
  { title: '社会热点', count: 58, icon: 'ri-fire-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '直播翻车', count: 52, icon: 'ri-live-line', color: 'text-primary-600 bg-primary-100' },
  { title: '时尚穿搭', count: 47, icon: 'ri-t-shirt-line', color: 'text-accent-600 bg-accent-100' },
  { title: '音乐动态', count: 41, icon: 'ri-music-line', color: 'text-secondary-600 bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            爆料合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            按分类浏览你最感兴趣的吃瓜内容，海量爆料等你发现
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-3 p-4 md:p-5 bg-background-100 border border-background-200/60 rounded-xl hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {item.count} 条爆料
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}